enum INITIAL_OPTION {
    /**
     * default, schedule a job base on lastSuccessTime
     */
    BASE_ON_LAST_TIME = 'BASE_ON_LAST_TIME',
    /**
     * execute immediately
     */
    FIRE_IMMEDIATELY = 'FIRE_IMMEDIATELY',
    /**
     * will execute job after intervalSeconds
     */
    IGNORE_FIRST_TIME = 'IGNORE_FIRST_TIME',
}

type JobInfo = {
    /**
     * unique key used to identify the current schedule job
     */
    key: string;
    /**
     * will schedule intervalSeconds_timer after job finish
     */
    intervalSeconds: number;
    /**
     * the main execute function for schedule
     */
    executeFunc: () => Promise<void> | void;
    /**
     * timeout
     */
    timeoutMillisecond?: number;
};

type ExcutingJobInfo = {
    /**
     * jobId which created by setTimeout, use it to cancel job
     */
    jobId?: number;
    /**
     * whether the current job is executing
     */
    isExecuting?: boolean;
};

export { JobInfo, ExcutingJobInfo, INITIAL_OPTION };
